export const UsersData = [
    {
      "id": 1,
      "name": "John Doe",
      "group": "A",
      "age": 25,
      "mobileNo": "123-456-7890",
      "center": "Center 1",
      "daysLeft": 15,
      "img": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRyIN12XTr66j_7l7Id29y0_GkOwlgvA6qQOUmwvJ-XOw&s",
      "date": "2024-06-21",
      "time": "10:30 AM",
      "tablets": 2,
      "reports": "Report 1"
    },
    {
      "id": 2,
      "name": "Jane Smith",
      "group": "B",
      "age": 30,
      "mobileNo": "234-567-8901",
      "center": "Center 2",
      "daysLeft": 10,
      "img": "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8cmFuZG9tJTIwcGVyc29ufGVufDB8fDB8fHww",
      "date": "2024-06-22",
      "time": "11:00 AM",
      "tablets": 1,
      "reports": "Report 2"
    },
    {
      "id": 3,
      "name": "Jim Brown",
      "group": "A",
      "age": 27,
      "mobileNo": "345-678-9012",
      "center": "Center 3",
      "daysLeft": 25,
      "img": "https://i.pinimg.com/736x/ae/ec/c2/aeecc22a67dac7987a80ac0724658493.jpg",
      "date": "2024-06-23",
      "time": "09:00 AM",
      "tablets": 3,
      "reports": "Report 3"
    },
    {
      "id": 4,
      "name": "Jill White",
      "group": "C",
      "age": 22,
      "mobileNo": "456-789-0123",
      "center": "Center 4",
      "daysLeft": 18,
      "img": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSJQa10HhN-Bwd9brtC8UppKM8hoFk944gVD_sJq7auEw__XI3yNgkEtP5doi1yNc3Qfpg&usqp=CAU",
      "date": "2024-06-24",
      "time": "10:45 AM",
      "tablets": 2,
      "reports": "Report 4"
    },
    {
      "id": 5,
      "name": "Jake Black",
      "group": "B",
      "age": 35,
      "mobileNo": "567-890-1234",
      "center": "Center 1",
      "daysLeft": 12,
      "img": "https://xsgames.co/randomusers/assets/avatars/male/74.jpg",
      "date": "2024-06-25",
      "time": "11:15 AM",
      "tablets": 1,
      "reports": "Report 5"
    },
    {
      "id": 6,
      "name": "Julia Green",
      "group": "C",
      "age": 29,
      "mobileNo": "678-901-2345",
      "center": "Center 2",
      "daysLeft": 30,
      "img": "https://xsgames.co/randomusers/assets/avatars/male/77.jpg",
      "date": "2024-06-26",
      "time": "10:00 AM",
      "tablets": 3,
      "reports": "Report 6"
    },
    {
      "id": 7,
      "name": "Joe Blue",
      "group": "A",
      "age": 26,
      "mobileNo": "789-012-3456",
      "center": "Center 3",
      "daysLeft": 20,
      "img": "https://i.pinimg.com/564x/a2/de/39/a2de3954697c636276192afea0a6f661.jpg",
      "date": "2024-06-27",
      "time": "09:30 AM",
      "tablets": 2,
      "reports": "Report 7"
    },
    {
      "id": 8,
      "name": "Janet Grey",
      "group": "B",
      "age": 28,
      "mobileNo": "890-123-4567",
      "center": "Center 4",
      "daysLeft": 5,
      "img": "https://randomuser.me/api/portraits/women/26.jpg",
      "date": "2024-06-28",
      "time": "11:45 AM",
      "tablets": 1,
      "reports": "Report 8"
    },
    {
      "id": 9,
      "name": "Jerry Red",
      "group": "C",
      "age": 31,
      "mobileNo": "901-234-5678",
      "center": "Center 1",
      "daysLeft": 22,
      "img": "https://randomuser.me/api/portraits/women/79.jpg",
      "date": "2024-06-29",
      "time": "10:15 AM",
      "tablets": 3,
      "reports": "Report 9"
    },
    {
      "id": 10,
      "name": "Jessica Yellow",
      "group": "A",
      "age": 24,
      "mobileNo": "012-345-6789",
      "center": "Center 2",
      "daysLeft": 8,
      "img": "https://randomuser.me/api/portraits/women/79.jpg",
      "date": "2024-06-30",
      "time": "09:45 AM",
      "tablets": 2,
      "reports": "Report 10"
    },
    {
      "id": 11,
      "name": "James Violet",
      "group": "B",
      "age": 32,
      "mobileNo": "123-456-7891",
      "center": "Center 3",
      "daysLeft": 14,
      "img": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRyIN12XTr66j_7l7Id29y0_GkOwlgvA6qQOUmwvJ-XOw&s",
      "date": "2024-07-01",
      "time": "10:30 AM",
      "tablets": 1,
      "reports": "Report 11"
    },
    {
      "id": 12,
      "name": "Jasmine Orange",
      "group": "C",
      "age": 33,
      "mobileNo": "234-567-8902",
      "center": "Center 4",
      "daysLeft": 7,
      "img": "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8cmFuZG9tJTIwcGVyc29ufGVufDB8fDB8fHww",
      "date": "2024-07-02",
      "time": "11:00 AM",
      "tablets": 3,
      "reports": "Report 12"
    },
    {
      "id": 13,
      "name": "Jack Indigo",
      "group": "A",
      "age": 34,
      "mobileNo": "345-678-9013",
      "center": "Center 1",
      "daysLeft": 1,
      "img": "https://i.pinimg.com/736x/ae/ec/c2/aeecc22a67dac7987a80ac0724658493.jpg",
      "date": "2024-07-03",
      "time": "10:00 AM",
      "tablets": 2,
      "reports": "Report 13"
    },
    {
      "id": 14,
      "name": "Julie Cyan",
      "group": "B",
      "age": 23,
      "mobileNo": "456-789-0124",
      "center": "Center 2",
      "daysLeft": 16,
      "img": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSJQa10HhN-Bwd9brtC8U",
      "date": "2024-07-03",
      "time": "10:00 AM",
      "tablets": 2,
      "reports": "Report 13"
    }
]
  